<template>
    <div>
      <title>Checkout</title>
      <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet"
        integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC" crossorigin="anonymous">
      <div class="cont">
        <!-- <div class="load-products" @click="loadProducts">
          Load products
      </div> -->
        <stripe-pricing-table
          pricing-table-id="prctbl_1QvIZPE4OWD2B5L5aL8Y55LF"
          publishable-key="pk_test_51OnGXjE4OWD2B5L55YrEwDShK8w2kMFXgniqI2eU7KygwTAP5x0ogxw3JTlwKkJc1yseTaOlq8HGaHjiUmhTeEsO00YolF0w5G"
          :customer-email="customeremail"
        >
        </stripe-pricing-table>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: ["customeremail"],
    methods: {
        loadProducts(){
            axios.post('/api/stripe/loadproducts').then(response => {
                console.log(response.data);
            });
        }
    },
  };
  </script>

<style lang="scss" scoped>
* {
    font-family: Roboto;
}

a {
    cursor: pointer;
}

.cont {
    width: 1188px;
    margin: 50px auto 0 auto;
    background: #FFFFFF;
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);
    padding: 57px 0 140px 0;

    @media only screen and (max-width: 1500px) {
        width: 95%;
    }

    .nadpis {
        width: 474px;

        @media only screen and (max-width: 600px) {
            width: 90%;
            text-align: center;
        }

        margin: 0 auto 20px auto;
        text-align: center;
        font-style: normal;
        font-weight: bold;
        font-size: 24px;
        line-height: 28px;
        color: #000000;
    }

    .main {
        width: 1030px;
        margin: 0 auto;
        background: #F2F7FB;
        border-radius: 5px;
        padding: 30px 0 50px 0;
        margin-bottom: 50px;

        @media only screen and (max-width: 1500px) {
            width: 90%;
        }
    }
}
</style>